import script from "./SidebarNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNavigation.vue?vue&type=style&index=0&id=47b67cb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b67cb2"]])

export default __exports__